import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=0b5b1a00&"
import script from "./AddQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./AddQuestionModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddQuestionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports